import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

const initialState = {
  loadingUsers: LOADING_STATUS.notLoading,
  loadingUser: LOADING_STATUS.notLoading,
  passwordWasReset: false,
  // Mirrors the `showDeactivated` URL search param of the last successful
  // fetch. False means the request carried `enabled=true`.
  showDeactivated: false,
  userFormValues: {
    all_groups: false,
    created: '',
    email: '',
    enabled: true,
    first_name: '',
    groups: [],
    id: null,
    last_login: null,
    last_login_ip: '',
    last_name: '',
    last_updated: '',
    permissions: [],
    permissionsList: [],
    uri: null,
    version: null,
  },
  users: [],
};

export const adminUsersSlice = createSlice({
  name: 'adminUsers',
  initialState,
  reducers: {
    setUserFormValues: (state, action) => {
      const { user } = action.payload;
      state.userFormValues = user;
    },
    setDefaultUser: (state) => {
      state.userFormValues = initialState.userFormValues;
    },
    setUsers: (state, action) => {
      const { users } = action.payload;
      state.users = users;
    },
    setLoadingUsers: (state, action) => {
      state.loadingUsers = action.payload;
    },
    setLoadingUser: (state, action) => {
      state.loadingUser = action.payload;
    },
    setPasswordWasReset: (state, action) => {
      state.passwordWasReset = action.payload;
    },
    setShowDeactivated: (state, action) => {
      state.showDeactivated = action.payload;
    },
    cleanUsersSlice() {
      return initialState;
    },
  },
});

export const {
  cleanUsersSlice,
  setDefaultUser,
  setUserFormValues,
  setUsers,
  setLoadingUser,
  setLoadingUsers,
  setPasswordWasReset,
  setShowDeactivated,
} = adminUsersSlice.actions;

export default adminUsersSlice.reducer;
